module.exports = __webpack_public_path__ + "static/media/icon_list.a1bd3807.svg";